/**
 * DescriptionContent component.
 */
import Container from '@components/atoms/container/descriptionContainer';
import Context from '@shared/components/utils/context/descriptionContext';
import Info from '@components/elements/description/descriptionInfo';
import Synopsis from '@components/atoms/text/descriptionSynopsis';
import Tip from '@components/elements/description/descriptionTip';
import Title from '@components/atoms/text/descriptionTitle';
import { useContext } from 'react';
import { DELAY } from '@shared/types/constants/animations';

/**
 * Renders the description content for the focused asset in a rail.
 */
export default function DescriptionContent() {
  const { display, metadata } = useContext(Context);
  const { synopsis, title } = metadata ?? {};
  return (
    <Container
      display={display}
      delay={display ? DELAY.DESCRIPTION_CONTENT : 0}
    >
      <Title>{title}</Title>
      <Info />
      <Synopsis>{synopsis}</Synopsis>
      <Tip />
    </Container>
  );
}
